import React from 'react';
import { connect } from 'react-redux';

import Pages from '@components/pages/Pages.tsx';
import mobMenuScrollTargetsTrigger from '@functions/mobMenuScrollTargetsTrigger.ts';
import { StoreT } from '@global/types.ts';

import PublicI from './types.ts';

import pages from './static/pages.tsx';

class Public extends React.Component<PublicI['props'], PublicI['state']> implements PublicI {
    parent: PublicI['parent'];

    constructor(props: PublicI['props']) {
        super(props);
        this.state = {
            loadPages: {},
        };

        this.parent = React.createRef();
    }

    pages = pages;

    render() {
        return (
            <>
                <div className="body__content">
                    <Pages
                        context={this}
                        pages={this.pages}
                        className="body__pages"
                        classNamePage="body__page _TARGET-SCROLL-MOB-MENU"
                        fullHeight={true}
                        filter={(page) => page.group === 'public'}
                        callback={() => {
                            mobMenuScrollTargetsTrigger();
                        }}
                    />
                </div>
            </>
        );
    }
}

function mapStateToProps(state: StoreT) {
    return {
        device: state.device,
        storePages: state.pages,
        levels: state.levels,
        user: state.user,
        tariffsOrder: state.tariffsOrder,
        isShowPublicMenu: state.isShowPublicMenu,
        seoData: state.seoData,
    };
}

export default connect(mapStateToProps)(Public);
